class CountySelector {
  constructor(observable) {
    this.observable = observable;
    this.select = document.querySelector('.counties-select');

    this.selected = this.selected.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  init(items) {
    const englandGroup = document.createElement('optgroup'),
      walesGroup = document.createElement('optgroup'),
      scotlandGroup = document.createElement('optgroup'),
      northernIrelandGroup = document.createElement('optgroup');

    englandGroup.label = 'England';
    walesGroup.label = 'Wales';
    scotlandGroup.label = 'Scotland';
    northernIrelandGroup.label = 'Northern Ireland';

    for(let i = 0; i < items.length; i++) {
      const opt = document.createElement('option');

      opt.value = items[i].id;
      opt.text = items[i].name;

      switch(items[i].country) {
        case 'England':
          englandGroup.appendChild(opt);
          break;
        case 'Wales':
          walesGroup.appendChild(opt);
          break;
        case 'Scotland':
          scotlandGroup.appendChild(opt);
          break;
        case 'Northern Ireland':
          northernIrelandGroup.appendChild(opt);
          break;
        default:
          this.select.appendChild(opt);
      }

      this.select.appendChild(englandGroup);
      this.select.appendChild(walesGroup);
      this.select.appendChild(scotlandGroup);
      this.select.appendChild(northernIrelandGroup);
    }

    this.reset();
    this.select.style.opacity = 1;

    this.bindEventListeners();
  }

  bindEventListeners() {
    this.select.addEventListener('change', this.selected);
  }

  selected() {
    const value = this.getValue();
    this.observable.publish('location-selected', value);
  }

  update(value) {
    this.select.value = value;
  }

  getValue() {
    return this.select.value;
  }

  reset() {
    this.select.selectedIndex = 0; // first option is selected
  }
}

export default CountySelector;